(function () {
  function swiperInit() {    
    subSliderInit(true);
    sliderInit(true);
    popupSliderInit(true);
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit();
  });

  if( window.location.search.indexOf('variant') == -1 ){
    swiperInit();
  }
})();
